export const ArrowRightCircle = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12 23.22C6.07 23.22 1.25 18.4 1.25 12.47C1.25 6.53997 6.07 1.71997 12 1.71997C17.93 1.71997 22.75 6.53997 22.75 12.47C22.75 18.4 17.93 23.22 12 23.22ZM12 3.21997C6.9 3.21997 2.75 7.36997 2.75 12.47C2.75 17.57 6.9 21.72 12 21.72C17.1 21.72 21.25 17.57 21.25 12.47C21.25 7.36997 17.1 3.21997 12 3.21997Z" />
    <path d="M14.5 13.22H8.5C8.09 13.22 7.75 12.88 7.75 12.47C7.75 12.06 8.09 11.72 8.5 11.72H14.5C14.91 11.72 15.25 12.06 15.25 12.47C15.25 12.88 14.91 13.22 14.5 13.22Z" />
    <path d="M12.4999 16.22C12.3099 16.22 12.1199 16.15 11.9699 16C11.6799 15.71 11.6799 15.23 11.9699 14.94L14.4399 12.47L11.9699 9.99997C11.6799 9.70997 11.6799 9.22997 11.9699 8.93997C12.2599 8.64997 12.7399 8.64997 13.0299 8.93997L16.0299 11.94C16.3199 12.23 16.3199 12.71 16.0299 13L13.0299 16C12.8799 16.15 12.6899 16.22 12.4999 16.22Z" />
  </svg>
);
